import { RestClient } from './RestClient'

export class InviteClient extends RestClient {
  /**
   * InviteClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    this.baseUrl = '/invitations'
  }

  /**
   * Accept an invite and join the team
   *
   * @param token
   *
   * @returns {AxiosPromise}
   */
  accept (token) {
    return this.call('post', `${this.baseUrl}/accept`, { token })
  }

  /**
   * List all invites for a team
   *
   * @param {number} team
   *
   * @returns {AxiosPromise}
   */
  list (team) {
    return this.call('get', `/teams/${team}/invitations`)
  }

  /**
   * Create new invite
   *
   * @param {number} team
   * @param {object} data
   *
   * @returns {AxiosPromise}
   */
  create (team, data) {
    return this.call('post', `/teams/${team}/invitations`, data)
  }

  /**
   * Delete an invite
   *
   * @param {number} id
   *
   * @returns {AxiosPromise}
   */
  remove (id) {
    return this.call('delete', `${this.baseUrl}/${id}`)
  }

  /**
   * Preview an invite and the connected team
   *
   * @param {string} token
   *
   * @returns {AxiosPromise}
   */
  preview (token) {
    return this.call('get', `${this.baseUrl}/preview/${token}`)
  }
}
